import React from "react";
import { createRoot } from "react-dom/client";
import { addInitialFunction, Context } from "./dfm5";
import { getAllPublishedCourses, getSchoolCourses } from "~/utils/courses";
import { posthogPageviewEvent } from "~/utils/posthog/general";
import BrowseCourses from "~/components/pages/browse-courses/BrowseCourses";

const root = createRoot(document.getElementById("react-root"));

async function renderPage() {
  // Set the user object from context.
  const user = Context?.user;

  // Determine whether to render the component in add mode.
  const params = new URL(document.location.toString()).searchParams;
  const mode = params.get("mode") ?? null;
  const addMode = mode === "add" && ["admin", "teacher", "trust"].includes(user?.type);

  // Render the component in a loading state.
  root.render(
    <BrowseCourses
      addMode={addMode}
      isLoading={true}
      user={user}
    />,
  );

  // Get the required data to render the component with courses.
  const [schoolCourses, authors] = await Promise.all([
    user?.sid ? getSchoolCourses({ sid: user.sid }) : [],
    getAllPublishedCourses(),
  ]);

  // Reshape the published courses, arranged by author, into a list of all courses.
  const publishedCourses = [];
  authors.forEach((author) => {
    const { courses = [], ...rest } = author;
    courses.forEach((course) => {
      publishedCourses.push({ ...course, author: rest });
    });
  });

  // Get a map of the authors array without the courses.
  const authorsWithoutCourses = authors.map(({ courses, ...rest }) => rest);

  // Get a list of any published course ids that the user's school has already added.
  const preAddedCourseIds = schoolCourses.map((course) => course.coid);

  // Render the react component, passing the required data.
  root.render(
    <BrowseCourses
      addMode={addMode}
      authors={authorsWithoutCourses}
      isLoading={false}
      preAddedCourseIds={preAddedCourseIds}
      publishedCourses={publishedCourses}
      user={user}
    />,
  );
}

$(() => {
  // Send a page view event when Context is available.
  addInitialFunction(posthogPageviewEvent);

  // Also send a page view event if we've navigated here via the bfcache
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      posthogPageviewEvent();
    }
  });

  addInitialFunction(() => renderPage());
});
